import { CampaignBannerList } from 'campaign';
import { useBodyClass } from 'common';
import Button from 'components/UI/Button';
import ScrollToTop from 'components/UI/ScrollToTop';
import { push } from 'connected-react-router';
import { FilterableCategoryProductGrid, ProductCarousel, ProductContext, ProductGrid, } from 'product';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import FocusHero from '../components/FocusHero';
import './FocusPage.scss';
import { Helmet } from 'react-helmet';
function getRelatedCategories(relatedCategories, topLevelCategories) {
    let categories = [];
    topLevelCategories.forEach((topLevelCategory) => {
        if (relatedCategories.some((rc) => rc === topLevelCategory.id)) {
            const matchingSubCategories = topLevelCategory.children.filter((c) => relatedCategories.some((rc) => rc === c.id));
            if (matchingSubCategories.length > 0) {
                categories.push(...matchingSubCategories);
            }
            else {
                categories.push(topLevelCategory);
            }
        }
    });
    return categories;
}
function FocusPage({ location }) {
    var _a, _b;
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const focusPageSlug = location.pathname.substring(1);
    console.log(focusPageSlug);
    const focusPagesAreFetched = useSelector((state) => state.focus.isFetched);
    const productsAreLoading = useSelector((state) => state.products.productsLoading);
    const allProducts = useSelector((state) => state.products.products);
    const topLevelCategories = useSelector((state) => state.products.categories);
    const focusPage = useSelector((state) => state.focus.focusPages.find((f) => f.urlSlug === focusPageSlug));
    const allCampaigns = useSelector((state) => state.campaign.campaigns);
    const useCarousel = useSelector((state) => state.ui.isMobile || state.ui.isTablet);
    useBodyClass(`background--${(_a = focusPage === null || focusPage === void 0 ? void 0 : focusPage.themeColor) === null || _a === void 0 ? void 0 : _a.value}`);
    if (!focusPagesAreFetched || productsAreLoading || !allProducts || !topLevelCategories) {
        return null;
    }
    if (!focusPage) {
        dispatch(push('/'));
        return null;
    }
    const relatedCategories = getRelatedCategories(focusPage.related_categories, topLevelCategories);
    const featuredProducts = allProducts.filter((p) => focusPage.featuredProducts.some((fp) => fp === p.id));
    const relatedProducts = allProducts.filter((p) => p.category.some((c) => relatedCategories.some((rc) => rc.id === c.id)));
    const campaigns = allCampaigns.filter((c) => focusPage.campaigns.indexOf(c.id) > -1);
    return (React.createElement(React.Fragment, null,
        React.createElement(Helmet, null,
            React.createElement("title", null,
                focusPage.title,
                " - Morgenlevering"),
            React.createElement("meta", { property: "og:title", content: `${focusPage.title} - Morgenlevering` }),
            React.createElement("meta", { property: "og:url", content: `https://morgenlevering.no/${focusPage.urlSlug}` })),
        React.createElement("div", { className: "focus-page" },
            React.createElement(ScrollToTop, null),
            React.createElement(FocusHero, { title: focusPage.title, backgroundImageUrl: (_b = focusPage.headerImage) === null || _b === void 0 ? void 0 : _b.large }),
            React.createElement("div", { className: "focus-page__main-content" },
                focusPage.heading && (React.createElement("h1", { className: "focus-page__heading" }, focusPage.heading)),
                focusPage.ingress && (React.createElement("p", { className: "focus-page__ingress" }, focusPage.ingress)),
                featuredProducts && featuredProducts.length > 0 && (React.createElement("div", { className: "focus-page__featured-products" },
                    React.createElement(ProductContext.Provider, { value: `FocusPage_Featured_${focusPageSlug}` }, useCarousel ? (React.createElement(ProductCarousel, { title: t('focusFeaturedProductsHeading'), products: featuredProducts })) : (React.createElement(React.Fragment, null,
                        React.createElement("h2", null, t('focusFeaturedProductsHeading')),
                        React.createElement(ProductGrid, { products: featuredProducts })))))),
                relatedProducts && relatedProducts.length > 0 && (React.createElement("div", { className: "focus-page__related-products" },
                    React.createElement("h2", null, t('focusRelatedProductsHeading')),
                    React.createElement(ProductContext.Provider, { value: `FocusPage_Grid_${focusPageSlug}` },
                        React.createElement(FilterableCategoryProductGrid, { products: relatedProducts, categories: relatedCategories, showCount: false }),
                        React.createElement("div", { className: "focus-page__related-products__button-container" },
                            React.createElement(Button, { onClick: () => dispatch(push('/products')) }, t('seeAllProductsButton'))))))),
            React.createElement(CampaignBannerList, { campaigns: campaigns }))));
}
export default FocusPage;
